/**
 * .env Exports
 */
// VITE_BACKEND='/' (production .env) means "same origin" — nginx routes
// /api/* to the backend — so it resolves to the host origin. Trailing slashes
// on real URLs are stripped because endpoints already start with '/', and
// '/' + '/api/...' would yield '//api/...' (read as protocol-relative).
const rawBackend = import.meta.env.VITE_BACKEND;
export const env_backend_url =
  !rawBackend || rawBackend === '/'
    ? window.location.protocol + '//' + window.location.host
    : rawBackend.replace(/\/+$/, '');
// Vite serves assets under `base` (see vite.config.js). BASE_URL mirrors what
// CRA exposed as PUBLIC_URL and is used to build the runtime CSS URLs.
export const env_public_url = import.meta.env.BASE_URL.replace(/\/$/, '');
